<template>
  <div class="vx-row">
    <div id="UsuariosIndicacoes" class="vs-con-loading__container">
      <vx-card class="overflow-hidden">
        <div slot="no-body">
          <div
            :class="'p-6 pt-6 pb-3 mb-3 flex justify-between flex-row-reverse items-center'"
          >
            <feather-icon
              :icon="'UsersIcon'"
              class="p-3 inline-flex rounded-full"
              :class="[`text-success`]"
              :style="{ background: `rgba(var(--vs-success),.15)` }"
            ></feather-icon>
            <div>
              <h2 class="mb-1 font-bold">Programa de Afiliados (à liberar)</h2>
            </div>
          </div>
          <div class="p-6 pb-0">
            <listUsuariosALiberar></listUsuariosALiberar>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import listUsuariosALiberar from "../usuarios/ListUsuariosALiberar.vue";

export default {
  components: {
    listUsuariosALiberar,
  },
};
</script>
